"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentListUrlFromJSON = ContentListUrlFromJSON;
exports.ContentListUrlFromJSONTyped = ContentListUrlFromJSONTyped;
exports.ContentListUrlToJSON = ContentListUrlToJSON;
exports.ContentListUrlToJSONTyped = ContentListUrlToJSONTyped;
const runtime_1 = require("../runtime");
function ContentListUrlFromJSON(json) {
    return ContentListUrlFromJSONTyped(json, false);
}
function ContentListUrlFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dataPayload': !(0, runtime_1.exists)(json, 'dataPayload') ? undefined : json['dataPayload'],
        'url': !(0, runtime_1.exists)(json, 'url') ? undefined : json['url'],
    };
}
function ContentListUrlToJSON(value) {
    return ContentListUrlToJSONTyped(value, false);
}
function ContentListUrlToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dataPayload': value.dataPayload,
        'url': value.url,
    };
}
